import { Button, Collapse, Container, Typography } from "@mui/material";
import React from "react";
import { TitleWithBody } from "../../types/utils";
import { Marksome } from "react-marksome";

const CollapsibleText = (props: TitleWithBody) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <Container disableGutters sx={styles.mainContainer}>
      <Button onClick={handleExpandClick} variant="outlined" fullWidth sx={styles.button}>
        <Typography variant="h6" align="center" sx={styles.title}>
          {props.title}
        </Typography>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Typography variant="body1" align="center" sx={styles.text}>
            <Marksome text={props.body} references={props.references} />
          </Typography>
        </Collapse>
      </Button>
    </Container>
  );
};

export default CollapsibleText;

const styles = {
  mainContainer: {
    my: "2%",
  },
  button: {
    overflowWrap: "anywhere",
    py: "2%",
    display: "flex",
    flexDirection: "column",
    textTransform: "none",
  },
  title: {
    color: "black",
  },
  text: {
    color: "#393939",
  },
};
